<template>
  <div>
    <div class="banner">
      <img :src="banner" v-if="clientWidth > 768" alt="" />
      <img :src="banner_m" v-if="clientWidth <= 768" alt="" />
    </div>

    <div class="module module1">
      <div class="wrap">
        <div class="per_box1">
          <div class="per_header">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_person.png" alt="" />
            <span>{{ islogin ? userInfo.Name : "暂未登录" }}</span>
            <span class="goout" v-if="islogin" @click="goOut" v-ga="{
              event: 'trk',
              ec: 'mypoints',
              ea: 'loginmypoints',
              el: 'logout',
            }">退出登录</span>
          </div>
          <div class="per_content">
            <div class="per_content_title1 fx1">
              <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_circle.png" alt="" />
              <span>我的积分</span>
            </div>
            <div class="per_content_title2 fx1">
              <span>累计总积分：</span>
              <span>{{ islogin ? pointAll.Integral : "0" }}</span>
              <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_coin.png" alt="" />
            </div>
            <div class="per_content_title3 fx8" v-if="!islogin">
              <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_none.png" alt="" />
              <p>
                您还没有积分哦~请立即<span @click="toLogin" v-ga="{
                  event: 'trk',
                  ec: 'pclogin',
                  ea: 'unlogmypoints',
                  el: 'login',
                }">注册登录</span>，
              </p>
              <p>参与有奖互动~</p>
            </div>
            <!-- 已登录 -->
            <div class="p_two_two_table" v-else>
              <div class="p_two_two_table_tr1">
                <div>互动方式</div>
                <div>获得积分</div>
              </div>
              <div class="p_two_two_table_tr_num num1">
                <div>注册会员</div>
                <div id="zchy">{{ pointAll.Register }}积分</div>
              </div>
              <div class="p_two_two_table_tr_num num2">
                <div>每日登录</div>
                <div id="mrll">{{ pointAll.Sign }}积分</div>
              </div>
              <div class="p_two_two_table_tr_num num1">
                <div>观看直播</div>
                <div id="mrll">{{ pointAll.WatchLive }}积分</div>
              </div>
              <div class="p_two_two_table_tr_num num2">
                <div v-html="clientWidth > 750 ? '直播小问答' : '直播<br>小问答'"></div>
                <div id="mrll">{{ pointAll.ClassQuestion }}积分</div>
              </div>
              <div class="p_two_two_table_tr_num num1">
                <div>咨询行业专家</div>
                <!-- <div class="feedbackinto">敬请期待</div> -->
                <div>
                  <span id="yjdy" v-if="pointAll.IndustryExperts != 0">{{ pointAll.IndustryExperts }}积分</span>
                  <span v-else>参与<span id="djclick" v-ga="{
                    event: 'trk',
                    ec: 'expert',
                    ea: 'expert',
                    el: 'now',
                  }" @click="toSurvey">咨询行业专家</span>
                    即可获取</span>
                </div>
              </div>
              <!-- <div class="p_two_two_table_tr_num num2" id="table-border">
                <div v-html="clientWidth > 750 ? '访问行业云展厅' : '访问<br>行业云展厅'
                  "></div>
                <div class="liveTopic">{{ pointAll.VisitCloud }}积分</div> -->
              <!-- <div><span id="yjdy">还未参加，</span><span id="djclick" onclick="djclicka(this)">立即参与</span></div> -->
              <!-- </div> -->
              <div class="p_two_two_table_tr_num num1">
                <div v-html="clientWidth > 750 ? '新品展示小问答' : '新品展示<br>小问答'
                  "></div>
                <div v-if="pointAll.NewProQuestion == 0">
                  未获得积分，<span id="djclick" @click="toExhibition" v-ga="{
                    event: 'trk',
                    ec: 'pclogin',
                    ea: 'loginmypoints',
                    el: 'answer',
                  }">立即答题</span>
                </div>
                <div v-else>{{ pointAll.NewProQuestion }}积分</div>
                <!-- <div>请关注施耐德电气官方公众号抽奖通知</div> -->
              </div>
              <div class="p_two_two_table_tr_num num2">
                <div>下载文档</div>
                <div id="xzwd">{{ pointAll.Dowlond }}积分</div>
              </div>
            </div>
          </div>
        </div>
        <div class="per_box2">
          <div class="per_title1 fx1">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_circle.png" alt="" />
            <span>赢取积分秘籍</span>
          </div>
          <p>
            09 月 11 日-10 月 16 日 2026 年工博会期间，每日登录活动微站参与互动，即可获取专属积分！积分可用于每日幸运抽奖！
          </p>
          <div class="p_th_th">
            <div class="p_th_th_table">
              <div class="p_th_th_table_tr1">
                <div>互动方式</div>
                <div>获得积分</div>
                <div>获取说明</div>
              </div>
              <div class="p_th_th_table_tr_num num1">
                <div>注册会员</div>
                <div>100积分</div>
                <div class="keep-line">
                  微站内<span @click="toLogin" v-if="!$store.state.islogin" class="login_btn" v-ga="{
                    event: 'trk',
                    ec: 'pclogin',
                    ea: 'unlogtips',
                    el: 'regis',
                  }">报名注册</span>
                  <span v-else class="normal_btn">报名注册</span>
                  即可获取
                </div>
              </div>
              <div class="p_th_th_table_tr_num p_th_th_table_tr_num2 num2">
                <div>每日登录</div>
                <div>50 积分</div>
                <div>9 月 11 日起至 10 月 11 日每日登录即可获得</div>
              </div>
              <div class="p_th_th_table_tr_num p_th_th_table_tr_num1 num1">
                <div>观看直播</div>
                <div>200 积分</div>
                <div>10 月 12 日-10 月 16 日进入直播间观看即可获取</div>
              </div>
              <div class="p_th_th_table_tr_num p_th_th_table_tr_num1 num2">
                <div v-html="clientWidth > 750 ? '直播小问答' : '直播<br>小问答'"></div>
                <div>50 积分</div>
                <div>
                  首次答题正确即可获得 50 会员积分，活动期间积分上限 300 分
                </div>
              </div>
              <div class="p_th_th_table_tr_num num1">
                <div>咨询行业专家</div>
                <div>300 积分</div>
                <div>参与咨询行业专家即可获取</div>
              </div>
              <!-- <div class="p_th_th_table_tr_num p_th_th_table_tr2 num2">
                <div v-html="clientWidth > 750 ? '访问行业云展厅' : '访问<br>行业云展厅'"></div>
                <div>300积分</div>
                <div>参与咨询行业专家即可获取</div>
              </div> -->
              <div class="p_th_th_table_tr_num num1" id="table-border">
                <div v-html="clientWidth > 750 ? '新品展示小问答' : '新品展示<br>小问答'"></div>
                <div>50 积分</div>
                <div>
                  答题正确即可获得 50 会员积分，活动期间积分上限 300 分
                </div>
              </div>
              <div class="p_th_th_table_tr_num p_th_th_table_tr_num2 num2">
                <div>下载文档</div>
                <div>50 积分</div>
                <div>首次下载文档即可获得 50 会员积分</div>
              </div>
            </div>
          </div>
          <div class="per_title1 fx1">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_circle.png" alt="" />
            <span>每日幸运抽奖</span>
          </div>
          <p>
            活动期间，我们将通过施耐德电气官方公众号，向当天在微站中参与互动的会员推送抽奖通知。推荐置顶施耐德电气官方公众号，以免错失获奖机会！
          </p>
          <div class="per_title2" :class="clientWidth > 768 ? 'fx1' : ''">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_arrow.png" alt="" />
            <span>活动时间：</span>
            <span v-if="clientWidth > 768">10 月 12 日-10 月 16 日，每晚 18:00，连续 5 天。</span>
            <p v-if="clientWidth <= 768">
              10 月 12 日-10 月 16 日，每晚 18:00，连续 5 天。
            </p>
          </div>
          <div class="per_title2" :class="clientWidth > 768 ? 'fx1' : ''">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_arrow.png" alt="" />
            <span>活动规则：</span>
            <span v-if="clientWidth > 768">活动期间登录的用户，每位用户每天最多可参与 5 次 抽奖，每次抽奖消耗 100 积分。若当日连续 4 次未中奖，第 5 次抽奖必得“25积分回血包”，好运连连不空手！</span>
            <p v-if="clientWidth <= 768">
              活动期间登录的用户，每位用户每天最多可参与 5 次 抽奖，每次抽奖消耗 100 积分。若当日连续 4 次未中奖，第 5 次抽奖必得“25积分回血包”，好运连连不空手！
            </p>
          </div>
          <div class="per_title2" :class="clientWidth > 768 ? 'fx1' : ''">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_arrow.png" alt="" />
            <span>重要提示：</span>
            <span v-if="clientWidth > 768">请中奖后及时在抽奖界面下方的【兑换礼品】添加您的收货地址，并确保信息填写准确，我们将在活动结束后寄出奖品。</span>
            <p v-if="clientWidth <= 768">
              请中奖后及时在抽奖界面下方的【兑换礼品】添加您的收货地址，并确保信息填写准确，我们将在活动结束后寄出奖品。
            </p>
          </div>
          <div class="per_gift" v-if="clientWidth > 768">
            <div class="gift_box">
              <div class="gift" v-for="(item, index) in giftlist" :key="index + 100">
                <img :src="item.img" alt="" />
                <div class="gift_name">{{ item.title }}</div>
              </div>
            </div>
            <div class="gift_box">
              <div class="gift" v-for="(item, index) in coinlist" :key="index + 200">
                <img :src="item.img" alt="" />
                <div class="gift_name">{{ item.title }}</div>
              </div>
            </div>
          </div>
          <div class="per_gift" v-else>
            <swiper :options="swiperOption" ref="mySwiper">
              <div class="swiper-button-prev swiper-button1" slot="button-prev"></div>
              <div class="swiper-button-next swiper-button1" slot="button-next"></div>
              <swiper-slide v-for="(item, index) in giftlist_m" :key="index + 300" class="gift">
                <img :src="item.img_m" alt="" />
                <div class="gift_name">{{ item.title }}</div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="per_title1 fx1">
            <span>活动声明：</span>
          </div>
          <div class="per_title3 fx1">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_circle1.png" alt="" />
            <span v-if="clientWidth > 768">以上全部活动时间为 2026 年工博会期间有效：2026 年 10 月 12 日-2026 年 10 月 16 日，逾期自动失效。</span>
            <span
              v-if="clientWidth <= 768">&nbsp;&nbsp;&nbsp;&nbsp;以上全部活动时间为 2026 年工博会期间有效：2026 年 10 月 11 日-2026 年 10 月 16 日，逾期自动失效。</span>
          </div>
          <div class="per_title3" :class="clientWidth <= 768 ? 'fx1' : ''">
            <img :class="clientWidth > 768 ? 'per_title3_img' : ''"
              src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_circle1.png" alt="" />
            <span
              v-if="clientWidth > 768">凡参与以上活动者，即视为接受活动所有规则，须遵循施耐德电气（中国）有限公司法律声明及其他关于营销活动的相关规定，且须遵循施耐德电气（中国）有限公司有权在法律允许的范围内对活动规则做出适当调整。</span>
            <span
              v-if="clientWidth <= 768">&nbsp;&nbsp;&nbsp;&nbsp;凡参与以上活动者，即视为接受活动所有规则，须遵循施耐德电气（中国）有限公司法律声明及其他关于营销活动的相关规定，且须遵循施耐德电气（中国）有限公司有权在法律允许的范围内对活动规则做出适当调整。</span>
          </div>
          <div class="per_title3 fx1">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_circle1.png" alt="" />
            <span v-if="clientWidth > 768">通过不当途径参加以上活动的行为，一经发现我公司有权终止该客户参加本次活动并取消其获奖资格。</span>
            <span v-if="clientWidth <= 768">&nbsp;&nbsp;&nbsp;&nbsp;通过不当途径参加以上活动的行为，一经发现我公司有权终止该客户参加本次活动并取消其获奖资格。</span>
          </div>
          <div class="per_title3 fx1">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_circle1.png" alt="" />
            <span v-if="clientWidth > 768">每个实物礼品只有一次获得机会。</span>
            <span v-if="clientWidth <= 768">&nbsp;&nbsp;&nbsp;&nbsp;每个实物礼品只有一次获得机会。</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, EffectFade]);

import { UserIntegralInfo } from "../../api/index.js";
import { setCookie, removeCookie } from "../../utils/_handleCookie";
import { GetUserLogs, AddPoints } from "@/api/index.js";
import { Res_Url, Res_Url2026 } from "@/utils/ApiToken.js";
export default {
  data() {
    return {
      swiperOption: {
        direction: "horizontal",
        slidesPerView: 2,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      banner: Res_Url2026 + "/index/banner.png",
      banner_m: Res_Url2026 + "/index/banner_m.png",
      pointAll: {},
      giftlist: [

        {
          img: Res_Url2026 + "/personal/img_gift1.png",
          img_m:
            Res_Url2026 + "/personal/img_gift1_m.png",
          title: "攀高(PANGAO)颈椎按摩器",
        },
        {
          img: Res_Url2026 + "/personal/img_gift2.png",
          img_m:
            Res_Url2026 + "/personal/img_gift2_m.png",
          title: "飞利浦无线蓝牙耳机",
        },
        {
          img: Res_Url2026 + "/personal/img_gift3.png",
          img_m:
            Res_Url2026 + "/personal/img_gift3_m.png",
          title: "施耐德电气萱绎系列排插",
        },
        
      ],
      coinlist: [
        {
          img: Res_Url2026 + "/personal/img_gift4.png",
          img_m: Res_Url2026 + "/personal/img_gift_m4.png",
          title: "精油香薰礼盒套装",
        },
        {
          img: Res_Url2026 + "/personal/img_gift5.png",
          img_m:
            Res_Url2026 + "/personal/img_gift_m5.png",
          title: "施耐德电气定制鼠标垫",
        },
        
      ],
      giftlist_m: [

        {
          img: Res_Url2026 + "/personal/img_gift1.png",
          img_m:
            Res_Url2026 + "/personal/img_gift1_m.png",
          title: "攀高(PANGAO)颈椎按摩器",
        },
        {
          img: Res_Url2026 + "/personal/img_gift2.png",
          img_m:
            Res_Url2026 + "/personal/img_gift2_m.png",
          title: "飞利浦无线蓝牙耳机",
        },
        {
          img: Res_Url2026 + "/personal/img_gift3.png",
          img_m: Res_Url2026 + "/personal/img_gift3_m.png",
          title: "施耐德电气萱绎系列排插",
        },
        {
          img: Res_Url2026 + "/personal/img_gift4.png",
          img_m: Res_Url2026 + "/personal/img_gift4_m.png",
          title: "精油香薰礼盒套装",
        },
        {
          img: Res_Url2026 + "/personal/img_gift5.png",
          img_m:Res_Url2026 + "/personal/img_gift5_m.png",
          title: "施耐德电气定制鼠标垫",
        },
      ],
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  mounted() {
    GetUserLogs({
      visitName: "页面访问-个人中心",
      visitType: 1,
      url: window.location.href,
      track: this.$route.query.track ? this.$route.query.track : 11058,
    });
    setTimeout(() => {
      // console.log(JSON.parse(sessionStorage.getItem('params')))
      this.UserIntegralInfo();
    }, 500);
  },
  methods: {
    toExhibition() {
      var params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$store.commit("activeIndex", 3);
      this.$router.push({
        name: "Exhibition",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
    },
    toSurvey() {
      AddPoints({
        visitType: 31,
        track: this.$route.query.track ? this.$route.query.track : "",
        name: '',
        email: '',
      }).then((res) => {
        if (res.Status === 1) {
          window.location.href = 'https://events.schneider-electric.cn/new_edition/schneider/p2s/tozhiqu.html?utm_campaign=CN_202610_All-Campaign-CIIF&se_sr=SEemssite&se_md=owned';

        }
      });
    },
    goOut() {
      this.$eventBus.$emit('message', '退出登录');
      if (/(micromessenger)/i.test(navigator.userAgent)) {
        setCookie("QC_Token2026", '%%')
      } else {
        removeCookie("QC_Token2026");
        removeCookie("gongBoOpenId2026");
      }

      this.$store.commit("islogin", false);
      let params = this.$route.query;
      this.$store.commit("activeIndex", 0);
      this.$router.push({
        path: "/Home/Index",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
      // location.reload();
    },
    toLogin() {
      if (!this.$store.state.islogin) {
        let params = this.$route.query;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        let querys;
        querys = {
          backlink: encodeURIComponent(window.location.href),
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        };
        this.$router.push({
          name: "Register",
          query: querys,
        });
      }
    },
    UserIntegralInfo() {
      UserIntegralInfo().then((res) => {
        if (res.Status == 1) {
          this.pointAll = res.Data;
        }
      });
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    islogin() {
      return this.$store.state.islogin;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>